import { render, staticRenderFns } from "./CartHeading.vue?vue&type=template&id=43d3da70&"
import script from "./CartHeading.vue?vue&type=script&lang=js&"
export * from "./CartHeading.vue?vue&type=script&lang=js&"
import style0 from "./CartHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports